"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("./DomainObject");

var AdtFlag =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(AdtFlag, _DomainObject_1$Domai);

  function AdtFlag() {
    var _this;

    _classCallCheck(this, AdtFlag);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AdtFlag).apply(this, arguments));
    _this.tag = _this.constructor.name;
    return _this;
  }

  _createClass(AdtFlag, [{
    key: "copy",
    value: function copy(field, value) {
      if (field === 'tag') {
        throw new Error('Can not change `tag` field');
      }

      return _get(_getPrototypeOf(AdtFlag.prototype), "copy", this).call(this, field, value);
    }
  }], [{
    key: "registerBase",
    value: function registerBase(base, ctor, tag) {
      tag = tag || ctor.name;
      var map = AdtFlag.domains.get(base);

      if (map === undefined) {
        map = new Map();
        AdtFlag.domains.set(base, map);
      }

      var ctor2 = map.get(tag);

      if (ctor2 !== undefined && ctor2 !== ctor) {
        throw new Error('Duplicated tag ' + tag + ' for base ' + base.TAG);
      }

      if (ctor2 === undefined) {
        map.set(tag, ctor);
      }

      return tag;
    }
  }, {
    key: "deserializeBase",
    value: function deserializeBase(base, data) {
      if (typeof data !== 'object' || data === null) {
        throw new Error('Can not deserialize from: ' + JSON.stringify(data));
      }

      if (typeof data.tag !== 'string') {
        throw new Error('No `tag` attribute in: ' + data.toString());
      }

      var ctor = AdtFlag.getConstructorBase(base, data.tag);
      var ret = Object.setPrototypeOf(data, ctor.prototype);

      if (!ret.validate()) {
        throw new Error('Validation failed for base ' + base.TAG + ' and tag ' + data.tag + ': ' + JSON.stringify(data));
      }

      return ret;
    }
  }, {
    key: "getConstructorBase",
    value: function getConstructorBase(base, tag) {
      var map = AdtFlag.domains.get(base);

      if (map === undefined) {
        throw new Error('Unknown base: ' + base.TAG);
      }

      var ctor = map.get(tag);

      if (ctor === undefined) {
        throw new Error('Tag ' + tag + ' not registered for base: ' + base.TAG);
      }

      return ctor;
    }
  }, {
    key: "findInList",
    value: function findInList(flags, ctor) {
      var ret = flags.find(function (f) {
        return f instanceof ctor;
      });
      return ret ? ret : null;
    }
  }, {
    key: "findInArray",
    value: function findInArray(flags, ctor) {
      var ret = flags.find(function (f) {
        return f instanceof ctor;
      });
      return ret ? ret : null;
    }
  }, {
    key: "serialize",
    value: function serialize(flag) {
      var ret = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = Object.getOwnPropertyNames(flag)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var k = _step.value;
          ret[k] = flag[k];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return ret;
    }
  }]);

  return AdtFlag;
}(DomainObject_1.DomainObject);

exports.AdtFlag = AdtFlag;
AdtFlag.TAG = '__BASE__';
AdtFlag.domains = new Map();